// Clock-sync с сервером: 5 пингов, медиана (как NTP, спека §3.3).

export async function measureServerDelta(pings = 5): Promise<number> {
  const deltas: number[] = [];
  for (let i = 0; i < pings; i++) {
    const t0 = Date.now();
    const response = await fetch('/api/time');
    const t1 = Date.now();
    if (!response.ok) throw new Error('time sync failed');
    const { now } = (await response.json()) as { now: number };
    deltas.push(now + (t1 - t0) / 2 - t1);
  }
  deltas.sort((a, b) => a - b);
  return deltas[Math.floor(deltas.length / 2)];
}
